<template>
  <div class="pt-10">
    <ImportPortfolioDetails :reportData="reportData"/>
    <ImportPortfolioDuplicates v-if="reportHasDuplicates"
                               :duplicates="duplicatesCopy"
                               @toggleExclude="toggleDuplicateExclude($event)"/>
    <div class="space-x-8 mt-12">
      <BaseButton class="col-span-1"
                  theme="red" size="sm"
                  @click="apply"
                  :loading="submitted">
        {{ $t('importReport') }}
      </BaseButton>
      <BaseButton class="col-span-1"
                  theme="default" size="sm"
                  @click="cancel"
                  :loading="submitted">
        {{ $t('cancel') }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import BaseButton from "@/components/UI/BaseButton";
import ImportPortfolioDetails
  from "@/components/cabinet/Investments/modals/ImportPortfolioModal/ImportPortfolioStep2/ImportPortfolioDetails";
import ImportPortfolioDuplicates
  from "@/components/cabinet/Investments/modals/ImportPortfolioModal/ImportPortfolioStep2/ImportPortfolioDuplicates";

export default {
  name: "ImportPortfolioStep2",
  components: {ImportPortfolioDuplicates, ImportPortfolioDetails, BaseButton},
  props: {
    submitted: {
      type: Boolean,
      required: true
    },
    reportData: {
      type: Object
    }
  },
  data() {
    return {
      duplicatesCopy: []
    }
  },
  computed: {
    ...mapState('investments/portfolios', ['current_portfolio']),
    reportHasDuplicates() {
      return !!this.reportData.duplicateDeals.length;
      // return true
    }
  },
  methods: {
    toggleDuplicateExclude(index) {
      this.duplicatesCopy[index].exclude = !this.duplicatesCopy[index].exclude
    },
    apply() {
      let appliedDuplicateIds = []
      if (!!this.reportData.duplicateDeals.length) {
        appliedDuplicateIds = this.duplicatesCopy.filter(item => !item.exclude).map(item => item.index)
      }
      this.$emit('applyReport', appliedDuplicateIds)
    },
    cancel() {
      //dispatch empty upload to clear current parsed report
      this.$store.dispatch('investments/portfolios/uploadPortfolio',
          {portfolio_id: this.$store.state.investments.portfolios.current_portfolio.data.id});
      this.$emit('cancel');
    }
  },
  created() {
    if (!!this.reportData.duplicateDeals.length) {
      this.duplicatesCopy = [...this.reportData.duplicateDeals].map((deal) => ({...deal, exclude: true}));
    }
  },
  i18n: {
    messages: {
      en: {
        importReport: 'Import Report',
        cancel: 'Cancel'
      },
      ru: {
        importReport: 'Импортировать отчет',
        cancel: 'Отменить'
      }
    }
  }
}
</script>